const log = { logger: console };

export const setLogger = (logs: any) => {
  log.logger = logs;
};

export const logger = () => log.logger;
